import React from 'react';
import useTranslate from 'application/hooks/use-translate';

interface Props {
  onChange: (value: number | null) => void;
  value: number | null;
}

const ReportMonthSelector = ({ onChange, value }: Props) => {
  const translate = useTranslate('reports');

  return (
    <select
      id="report-month-selector"
      className="select-bordered select mr-4"
      onChange={(event) => onChange(Number(event.target.value))}
      defaultValue={value || ''}
    >
      <option value="" disabled>
        {translate('month')}
      </option>
      {Array.from({ length: 12 }, (_, index) => {
        const month = index + 1;

        return (
          <option key={month} value={month}>
            {translate(`months.${month}`)}
          </option>
        );
      })}
    </select>
  );
};

export default ReportMonthSelector;
